import { BootstrapVue } from "bootstrap-vue";
import VueRouter from "vue-router";
import Cookies from 'js-cookie'
// import "bootstrap-vue/dist/bootstrap-vue.css";
// import "bootstrap/dist/css/bootstrap.css";
import Vue from "vue";
import App from "./App.vue";
// import i18n from "./plugins/i18n";
// import Vue from "vue";
import VueI18n from "vue-i18n";
import routes from "./router.js";
import cardop from "./plugins/cardop";
import "./assets/css/custome.css";
import "./assets/css/popup.css";
import "./assets/css/style.css";
import "./assets/css/at.css"; //at-ui-style diy
import "./util/errrorMessage";
import store from "./store/index.js";
import verify from "vue-verify-plugin";
import VueClipboard from "vue-clipboard2";
import { number_format } from "./plugins/operation"

// import Buefy from 'buefy'
// import "./assets/css/buefy.css";
import ElementUI from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css' //element-ui的css


import iView from 'iview/dist/iview.js'
import locale from 'view-design/dist/locale/en-US';
import 'iview/dist/styles/iview.css';

// import AtComponents from 'at-ui'
// import 'at-ui-style'    // 引入组件样式
import { LoadingBar, Notification, Dialog, Message, Modal } from 'at-ui'


// import iView from 'iview/dist/iview.js'
// import { Message } from 'iview/dist/iview.js'
// import 'iview/dist/styles/iview.css';

// import ViewUI from 'view-design';
// import 'view-design/dist/styles/iview.css';

// import ViewUI from 'view-design';

// import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'



//全局登录弹窗组件
// import ModelToast from './public/toast'
// Vue.use(ModelToast)



// Vue.prototype.$Toast = Toast

// Vue.use(ViewUI);
// Vue.use(iView);
// Vue.use(MintUI)

Vue.use(iView, { locale });

Vue.use(VueClipboard);

Vue.use(verify, { blur: true });
Vue.use(ElementUI) //使用elementUI

// Vue.use(AtComponents)
Vue.prototype.$Loading = LoadingBar
Vue.prototype.$Notify = Notification
Vue.prototype.$Modal = Dialog
Vue.prototype.$Message = Message
Vue.prototype.$store = store()
Vue.prototype.$verify = verify
Vue.prototype.$cardop = cardop
// Vue.prototype.$Modal = Modal

Vue.prototype.$number_format = number_format

// Vue.use(Buefy)
Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(VueRouter);
// Vue.use(Loading)

Vue.config.productionTip = false;
const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
);

function loadLocaleMessages() {
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

function getLang() {
    let lang = window.location.pathname.replace(/^\/([^/]+).*/i, '$1');
    let result = 'en'
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched[1] == lang) {
            result = lang
        }
    });
    return result
}

let lang = getLang();

const router = new VueRouter({
    mode: "history",
    // base: process.env.BASE_URL,
    base: (lang.trim().length && lang != "/") ? '/' + lang : undefined,
    routes,
});

router.beforeEach((to, from, next) => {
    // ViewUI.LoadingBar.start();
    const token = Cookies.get("OTC919-token");
    // console.log((to.path.indexOf('/signin') > -1))
    // console.log('to.path:' + to.path)
    // console.log('lang:' + lang)
    // console.log('token:' + !!token)
    // console.log('fullPath:' + to.fullPath)

    // if (!token && (!(to.path.indexOf('/signin') > -1) || !(to.path.indexOf('/signup') > -1))) {
    // console.log(`!to.path.match(/(signin|signup)/) - ${!to.path.match(/(\/signin|\/signup)/)}`)
    // console.log(`没有登陆、并且没有在登陆注册页面 - ${!token && !to.path.match(/(\/signin|\/signup)/)}`)
    if (!token && !to.path.match(/(\/signin|\/signup|\/reset|\/cert_pendding)/)) {
        router.push({ 'path': `/signin?to=${to.fullPath}` })
        // window.location.href = `/${lang}/signin?to=` + location.pathname;
    } else {
        // Set locale based on url
        // i18n.locale = to.params.locale || i18n.locale;
        // Redirect to locale url based on from
        // console.log("lang && !to.fullPath.startsWith(`/${lang}`) - " + (lang && !to.fullPath.startsWith(`/${lang}`)))
        // console.log(`lang - ${lang}`)
        // console.log("!to.fullPath.startsWith(`/${lang}`) - " + !to.fullPath.startsWith(`/${lang}`))
        if (
            lang && !to.fullPath.startsWith(`/${lang}`)
        ) {
            try {
                // console.log('*** - ' + '/' + lang + to.fullPath)
            } catch (error) {
                if (error.name === 'NavigationDuplicated') {
                    // Do nothing
                } else {
                    throw error;
                }
            }
        } else {
            // console.log('---' + `/${lang ? lang + '/' : ""}signin`)
            // router.push({ 'path': `/${lang ? lang + '/' : ""}signin` })
            // router.push({ 'path': to.fullPath })
            // router.push({ 'path': to.fullPath })
        }
    }

    next();
});

router.afterEach(route => {
    // ViewUI.LoadingBar.finish();
});


// router.beforeEach((to, from, next) => {
//   if ((to.query.lang !== 'cn' && to.query.lang !== 'en')) {
//     if (from.query.lang === 'cn' || from.query.lang === 'en') {
//       to.query.lang = from.query.lang
//     }
//     else {
//       to.query.lang = 'en'
//     }
//     // to.query.profile = from.query.profile;
//     // to.query._ = Date.parse(new Date())
//     next({
//       path: to.path,
//       name: to.name,
//       query: to.query,
//       params: to.params,
//     })
//   } else {
//     next()
//   }

// });


// const lang = window.location.search.includes('lang=cn') ? 'cn' : (window.location.search.includes('lang=en') ? 'en' : 'jp');

const i18n = new VueI18n({
    locale: lang, // 语言标识
    messages: loadLocaleMessages(),
});

new Vue({
    router,
    i18n,
    render: (h) => h(App),
}).$mount("#app");